import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b29ff508")

_pushScopeId("data-v-b29ff508")
const _hoisted_1 = { class: "detail-ingredients-view" }
const _hoisted_2 = { class: "detail-ingredients-title-view-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "detail-ingredients-title-view" }, "材料", -1)
const _hoisted_4 = { class: "detail-ingredients-view-dropdown-area" }
const _hoisted_5 = { class: "detail-ingredients-view-theme-dropdown-area" }
const _hoisted_6 = { class: "detail-ingredients-view-variation-dropdown-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RecipeDropdownList = _resolveComponent("RecipeDropdownList")
  const _component_DetailDishItem = _resolveComponent("DetailDishItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("div", _hoisted_5, [
          _createVNode(_component_RecipeDropdownList, {
            dropdownList: _ctx.getThemeDrowDownList(),
            selectType: _ctx.getSelectThemeType(),
            type: _ctx.themeType,
            onSelectItem: _ctx.clickTheme
          }, null, 8, ["dropdownList", "selectType", "type", "onSelectItem"])
        ], 512), [
          [_vShow, _ctx.isShowTheme()]
        ]),
        _withDirectives(_createVNode("div", _hoisted_6, [
          _createVNode(_component_RecipeDropdownList, {
            "v-bind": _ctx.getSelectVariationType(),
            dropdownList: _ctx.getVariationDrowDownList(),
            selectType: _ctx.getSelectVariationType(),
            type: _ctx.variationType,
            onSelectItem: _ctx.clickVariation
          }, null, 8, ["v-bind", "dropdownList", "selectType", "type", "onSelectItem"])
        ], 512), [
          [_vShow, _ctx.isShowVariation()]
        ])
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getDishes(), (item) => {
      return (_openBlock(), _createBlock(_component_DetailDishItem, {
        key: item.id,
        id: item.id,
        title: item.title,
        cookingTool: item.cookingTool,
        dishItem: item.dish
      }, null, 8, ["id", "title", "cookingTool", "dishItem"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})